import axiosClient from "./axiosClient";

const servicesApi = {
  getAll: () => axiosClient.get("/services/?page=1&limit=10"),
  getById: (id) => axiosClient.get(`/services/${id}`),
  create: (data) => axiosClient.post("/admin/services", data),
  update: (id, data) => axiosClient.patch(`/admin/services/${id}`, data),
  updateImage: (id, data) => axiosClient.put(`/admin/services/${id}`, data),
  delete: (id) => axiosClient.delete(`/admin/services/${id}`)
};

export default servicesApi;
